export default {
  id: "sample",
  is_archived: false,
  created: "2021-10-24T18:13:05.561885-05:00",
  modified: "2021-10-24T18:13:19.288151-05:00",
  is_paid: true,
  is_locked: false,
  invitee: null,
  custom_css: "",
  user: { username: "landlord@test.com" },
  landlord: { name: "hahahha2" },
  applicant: {
    name: "Fred Flintstone",
    email: "fredflintstone@email.com",
    ssn: "XXX-XX-1938",
    phone: "555-555-5555"
  },
  is_a_la_carte_eligible: true,
  attachment_urls: [],
  price: "60.00",
  decision_date: null,
  decision_by: null,
  is_invitation: false,
  invitation_sent: false,
  status: "submitted",
  unit_address: "555 Sode Ridge",
  can_submit: true,
  need_applicant_experian_authtoken: false,
  template_slug: "sample",
  audit_logs: [],
  pdf_url: "",
  notes: "",
  summary: [
    {
      label: "Date of Birth",
      value: "1990-01-01"
    },
    {
      label: "Do you have any pets?",
      value: "No"
    },
    {
      label: "If so, please list each pet (Type, Weight, Color)",
      value: "None"
    },
    {
      value: "$1,000,000.00",
      label: "Total Anticipated Annual Income"
    },
    {
      label: "Do you smoke?",
      value: "No"
    },
    {
      label: "List Any Vehicles You Have (Vehicle Year, Make, Color, License #, State)",
      value: "None"
    },
    {
      label: "Other Occupants (if any)",
      value: "None"
    }
  ],
  form: {
    "report-EVC-Statewide": true,
    orientation: "horizontal",
    title: "Application Form",
    reports: [],
    id: 1,
    "report-CRM-Statewide": true,
    landlord_emails: "",
    "report-CRD-TransUnion": false,
    sections: [
      {
        fields: [
          {
            name: "applicant_email",
            editable: false,
            button: "Line",
            required: true,
            field_id: "email",
            value: "fu@fononma.gp",
            label: "What Is Your Email Address?",
            klass: null,
            help_text:
              "This is used only for your landlord to contact you or if you need to access your application.",
            validate_text: "--",
            validate: "email",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "unit",
            editable: false,
            button: "Multi Line",
            required: true,
            field_id: "unit_field",
            value: "555 Sode Ridge",
            label: "What Is The Address Of The Property You Are Applying To?",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Application Information"
      },
      {
        fields: [
          {
            name: "rental_property__proposed_rent_amount",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Ecasebcir ivevepvop unfein ruf ico rujocpi tipijsol isaom vecwe hu zihrul sev puzum da nu rane.",
            label: "Proposed Rent Amount",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "rental_property__desired_move_in_date",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Bamori zepolo sefbosrum ogu bibva nitrotet buili fuvmod veupowes cifegef ferdufer hurlo pizeh naerbis jewu dinev nomgejo ze.",
            label: "Desired Move In Date",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Rental Property"
      },
      {
        fields: [
          {
            name: "applicant__first_name",
            editable: false,
            button: "Name",
            required: true,
            field_id: "single_line",
            value: "Lillie",
            label: "First Name",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-user",
            placeholder: "Adam",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "applicant__last_name",
            editable: false,
            button: "Name",
            required: true,
            field_id: "single_line",
            value: "Pugi",
            label: "Last Name",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-user",
            placeholder: "Smith",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "applicant__ssn",
            button: "SSN",
            required: true,
            field_id: "ssn",
            value: "XXX-XX-4998",
            label: "SSN",
            klass: null,
            help_text: "",
            validate: "ssn",
            icon: "icon-barcode",
            placeholder: "",
            display_in_builder: false,
            tooltip_text: "Require a valid US social security number.",
            masked: "XXX-XX-4998"
          },
          {
            name: "applicant__date_of_birth",
            summary: true,
            button: "Date",
            required: true,
            field_id: "date",
            value: "1990-01-01",
            label: "Date of Birth",
            klass: "datesplit",
            help_text: "",
            validate: "date",
            icon: "icon-calendar",
            placeholder: "YYYY-MM-DD",
            display_in_builder: true,
            tooltip_text: "Any date."
          }
        ],
        button: "Personal Information",
        section_id: "personal-information",
        label: "Applicant Information"
      },
      {
        fields: [
          {
            name: "contact_information__email",
            button: "Email",
            required: false,
            field_id: "email",
            value: "mumig@suv.la",
            label: "Email",
            klass: null,
            help_text: "",
            validate: "email",
            icon: "icon-envelope",
            placeholder: "name@example.com",
            display_in_builder: true,
            tooltip_text: "Use this field if you want to require a valid email address."
          },
          {
            name: "contact_information__phone",
            button: "Phone",
            required: false,
            field_id: "phone",
            value: "244-603-9072",
            label: "Phone",
            klass: null,
            help_text: "",
            validate: "phone",
            icon: "icon-comment",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "A US phone number - 7 or 10 digits. Use this field if you want to require a valid phone number."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Contact Information"
      },
      {
        fields: [
          {
            name: "coapplicants_names",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Ej tiukihip tub biges fo lu mejja vigooho mehu nobtug oljubraw poro sud wivba ro mosov deh.",
            label: "Co-applicant names (if any)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "other_occupants",
            button: "Multi Line",
            required: false,
            field_id: "multi_line",
            summary: true,
            value: "None",
            label: "Other Occupants (if any)",
            klass: null,
            help_text: "Anyone else who will reside in the property (one per line)",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "Name, Age, Relationship",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Co-Applicants and Occupants"
      },
      {
        fields: [
          {
            name: "current_address__address1",
            button: "Name",
            required: true,
            field_id: "single_line",
            value: "727 Ihigo Pike",
            label: "Address Line 1",
            klass: null,
            help_text: "Example: 123 Street Name",
            validate_text: "--",
            validate: "",
            icon: "icon-user",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__address2",
            button: "Name",
            required: false,
            field_id: "single_line",
            value:
              "Ebozivwi zipowbez siv fipuzo fanoh emulag cufducnij ve lugtollo bimmajiz ispofef jiwemjew ame.",
            label: "Address Line 2",
            klass: null,
            help_text: "Example: Unit #5F",
            validate_text: "--",
            validate: "",
            icon: "icon-user",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__zip_code",
            button: "Name",
            required: true,
            field_id: "single_line",
            value: "60637",
            label: "Zip Code",
            klass: null,
            help_text: "Example: 10012",
            validate: "zipcode",
            icon: "icon-user",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__city",
            button: "Name",
            required: true,
            field_id: "single_line",
            value: "Tuwadanuz",
            label: "City",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-user",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__state",
            icon: "icon-user",
            button: "State",
            required: true,
            field_id: "state",
            value: "PA",
            choices: [
              { value: "AL", label: "Alabama" },
              { value: "AK", label: "Alaska" },
              { value: "AZ", label: "Arizona" },
              { value: "AR", label: "Arkansas" },
              { value: "CA", label: "California" },
              { value: "CO", label: "Colorado" },
              { value: "CT", label: "Connecticut" },
              { value: "DE", label: "Delaware" },
              { value: "DC", label: "District of Columbia" },
              { value: "FL", label: "Florida" },
              { value: "GA", label: "Georgia" },
              { value: "HI", label: "Hawaii" },
              { value: "ID", label: "Idaho" },
              { value: "IL", label: "Illinois" },
              { value: "IN", label: "Indiana" },
              { value: "IA", label: "Iowa" },
              { value: "KS", label: "Kansas" },
              { value: "KY", label: "Kentucky" },
              { value: "LA", label: "Louisiana" },
              { value: "ME", label: "Maine" },
              { value: "MD", label: "Maryland" },
              { value: "MA", label: "Massachusetts" },
              { value: "MI", label: "Michigan" },
              { value: "MN", label: "Minnesota" },
              { value: "MS", label: "Mississippi" },
              { value: "MO", label: "Missouri" },
              { value: "MT", label: "Montana" },
              { value: "NE", label: "Nebraska" },
              { value: "NV", label: "Nevada" },
              { value: "NH", label: "New Hampshire" },
              { value: "NJ", label: "New Jersey" },
              { value: "NM", label: "New Mexico" },
              { value: "NY", label: "New York" },
              { value: "NC", label: "North Carolina" },
              { value: "ND", label: "North Dakota" },
              { value: "OH", label: "Ohio" },
              { value: "OK", label: "Oklahoma" },
              { value: "OR", label: "Oregon" },
              { value: "PA", label: "Pennsylvania" },
              { value: "RI", label: "Rhode Island" },
              { value: "SC", label: "South Carolina" },
              { value: "SD", label: "South Dakota" },
              { value: "TN", label: "Tennessee" },
              { value: "TX", label: "Texas" },
              { value: "UT", label: "Utah" },
              { value: "VT", label: "Vermont" },
              { value: "VA", label: "Virginia" },
              { value: "WA", label: "Washington" },
              { value: "WV", label: "West Virginia" },
              { value: "WI", label: "Wisconsin" },
              { value: "WY", label: "Wyoming" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "State",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A dropdown of the US states and territories."
          },
          {
            name: "current_address__dates_of_residence",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Ji ke ave ojfac mave febaksu gulgok vedauz bahifet noes fadge hi dol viloz bubsifiz ikisi.",
            label: "Dates of Residence",
            klass: null,
            help_text: "When did you live at this address?",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "March 2010 - September 2012",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__landlord_name",
            button: "Line",
            required: true,
            field_id: "single_line",
            value:
              "Bavobu goha laju okosat serur mi osdo ko hesfo peshi cezwelefu dere ze suzil lu nowilpif wurju.",
            label: "Current Landlord",
            klass: null,
            help_text: "If you were the owner, leave this field blank",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__landlord_phone",
            button: "Line",
            required: true,
            field_id: "single_line",
            value:
              "Ce pudapa buoti ruzad ir fapwog kagefawo ome zi ve cukirori ru mu onji akeesa jiwuwona.",
            label: "Current Landlord Phone #",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_address__landlord_email",
            button: "Email",
            required: false,
            field_id: "single_line",
            value: "ce@honbeoku.bh",
            label: "Current Landlord Email Address",
            klass: null,
            help_text: "",
            validate: "email",
            icon: "icon-envelope",
            placeholder: "name@example.com",
            display_in_builder: true,
            tooltip_text: "Use this field if you want to require a valid email address."
          },
          {
            name: "current_address__no_landlord_explanation",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Ne bu zedlefen limo epi jehse pivodowi jabsu dut bepe sosavroj zi si zevabe fugan.",
            label: "No Landlord?",
            klass: null,
            help_text:
              "If you don't have a current landlord, please explain (mortgage, live with family, etc)",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          }
        ],
        button: "Contact Information",
        section_id: "contact-information",
        label: "Current Address"
      },
      {
        fields: [
          {
            name: "previous_address_1__address1",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "An uci vuv osetuhelo peafewip paonutod kiajiso piviz bobit finawpon fo ejaepodi ufa urada.",
            label: "Address Line 1",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__address2",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Fublundeh cat it doci rot ip zoj ipirupa wusu ca bouh zunva ra oli use diwa.",
            label: "Address Line 2",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__zip_code",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Sogesi si coru fav tagi rahno pa fesif kosol kef vu ilvupvu ili cu owhe esig vehota omfecilu.",
            label: "Zip Code",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__city",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Wahicoce ce ejiiv vo tojled hu tazjacmip tapu kamonsa saweeno kor zulijiv soffufho gi pite cec lu mi.",
            label: "City",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__state",
            icon: "icon-comment",
            button: "State",
            required: false,
            field_id: "state",
            value: "LA",
            choices: [
              { value: "AL", label: "Alabama" },
              { value: "AK", label: "Alaska" },
              { value: "AZ", label: "Arizona" },
              { value: "AR", label: "Arkansas" },
              { value: "CA", label: "California" },
              { value: "CO", label: "Colorado" },
              { value: "CT", label: "Connecticut" },
              { value: "DE", label: "Delaware" },
              { value: "DC", label: "District of Columbia" },
              { value: "FL", label: "Florida" },
              { value: "GA", label: "Georgia" },
              { value: "HI", label: "Hawaii" },
              { value: "ID", label: "Idaho" },
              { value: "IL", label: "Illinois" },
              { value: "IN", label: "Indiana" },
              { value: "IA", label: "Iowa" },
              { value: "KS", label: "Kansas" },
              { value: "KY", label: "Kentucky" },
              { value: "LA", label: "Louisiana" },
              { value: "ME", label: "Maine" },
              { value: "MD", label: "Maryland" },
              { value: "MA", label: "Massachusetts" },
              { value: "MI", label: "Michigan" },
              { value: "MN", label: "Minnesota" },
              { value: "MS", label: "Mississippi" },
              { value: "MO", label: "Missouri" },
              { value: "MT", label: "Montana" },
              { value: "NE", label: "Nebraska" },
              { value: "NV", label: "Nevada" },
              { value: "NH", label: "New Hampshire" },
              { value: "NJ", label: "New Jersey" },
              { value: "NM", label: "New Mexico" },
              { value: "NY", label: "New York" },
              { value: "NC", label: "North Carolina" },
              { value: "ND", label: "North Dakota" },
              { value: "OH", label: "Ohio" },
              { value: "OK", label: "Oklahoma" },
              { value: "OR", label: "Oregon" },
              { value: "PA", label: "Pennsylvania" },
              { value: "RI", label: "Rhode Island" },
              { value: "SC", label: "South Carolina" },
              { value: "SD", label: "South Dakota" },
              { value: "TN", label: "Tennessee" },
              { value: "TX", label: "Texas" },
              { value: "UT", label: "Utah" },
              { value: "VT", label: "Vermont" },
              { value: "VA", label: "Virginia" },
              { value: "WA", label: "Washington" },
              { value: "WV", label: "West Virginia" },
              { value: "WI", label: "Wisconsin" },
              { value: "WY", label: "Wyoming" }
            ],
            klass: null,
            help_text: "",
            validate: null,
            label: "State",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A dropdown of the US states and territories."
          },
          {
            name: "previous_address_1__dates_of_residence",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Di tawaan du mor oh ukodizgen awwurla borga vamed kal pab mo goewgig so evzi.",
            label: "Dates of Residence",
            klass: null,
            help_text: "When did you live at this address?",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "Oct 2006 - Feb 2010",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__landlord_name",
            button: "Line",
            required: true,
            field_id: "single_line",
            value:
              "Nejbew hip ibebavdoc ak kisut beuweiz hipepag cupre vapsimij muvuzsu pudwi distitsi.",
            label: "Previous Landlord Name",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__landlord_phone",
            button: "Line",
            required: true,
            field_id: "single_line",
            value:
              "Bawcasa enacafew sos tupliras caihog wethagis mim tilhor ukli tutevdug jav oki.",
            label: "Previous Landlord Phone Number",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_address_1__landlord_email",
            button: "Email",
            required: false,
            field_id: "single_line",
            value: "aziak@geha.br",
            label: "Previous Landlord Email Address",
            klass: null,
            help_text: "",
            validate: "email",
            icon: "icon-envelope",
            placeholder: "name@example.com",
            display_in_builder: true,
            tooltip_text: "Use this field if you want to require a valid email address."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Previous Address"
      },
      {
        fields: [
          {
            name: "current_employer__organization_name",
            button: "Line",
            required: true,
            field_id: "single_line",
            value:
              "Dus ova bose kojol pib ibu awehih lih duk cotu cugule kugoop cahubi muzokov jolicku caplidem.",
            label: "Employer",
            klass: null,
            help_text: "",
            validate: null,
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_employer__job_title",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Ig icci tu aso kekawra gistiv ize hurpunoho gepjer ija fusgo narbucte lojtiminu viosi rovvehca wuhrerew hegova mumwe.",
            label: "Position",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_employer__start_date",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Sa fo bibrohwu fuubmim fuw em ca luilked mubla guw noldinav etfat methufus ip.",
            label: "Employed Since (Year)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_employer__business_address",
            button: "Multi Line",
            required: false,
            field_id: "multi_line",
            value:
              "Misisulu vid savtu ginsaez bihpavon ufuebuwo wis sima ekoper bi wu zo lise uvoadiluk nifsikupo.",
            label: "Business Address (Address, City, State, Zip)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          },
          {
            name: "current_employer__supervisor_name",
            button: "Name",
            required: true,
            field_id: "single_line",
            value: "Moto noeriomo je cuni mel zuznarti nala wu oveafme teomi he cubab.",
            label: "Supervisor Name",
            klass: null,
            help_text: "",
            validate: null,
            icon: "icon-user",
            placeholder: "Adam Smith",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "current_employer__supervisor_phone",
            button: "Phone",
            required: true,
            field_id: "phone",
            value: "618-562-7261",
            label: "Supervisor Phone",
            klass: null,
            help_text: "",
            validate: "phone",
            icon: "icon-comment",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "A US phone number - 7 or 10 digits. Use this field if you want to require a valid phone number."
          },
          {
            tooltip_text: "A simple question that requires a one line response.",
            button: "Question",
            required: false,
            field_id: "single_line",
            value:
              "Dutjatcul vikki muvego gepotu af vizihca ape maw jo zemeko kib laresimor gov jez ovoote ifuweh.",
            label: "Supervisor Email",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            name: "current_employer__supervisor_email"
          }
        ],
        button: "References",
        section_id: "references",
        label: "Present Employer"
      },
      {
        fields: [
          {
            name: "previous_employer__organization_name",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Po fiturar melwi ju dolo gemiko dawmih ejic comuni be abfef dibdo.",
            label: "Previous Employer",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_employer__job_title",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Jobu wavzer wihmomok mifa row kihjifud ofeabeafa gaehu rimdetdel hovowva fusout fov loomo tar ukdus.",
            label: "Previous Position",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_employer__start_and_end_date",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Adinuj jurgito cuvobzu jabu bo tucbor custeuw ubheb buof ugo uvdu za dab eve.",
            label: "Employed Duration (Start Date -> End Date)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_employer__business_address",
            button: "Multi Line",
            required: false,
            field_id: "multi_line",
            value:
              "Neg buhrakfu afu onoatinuz uwjaf bov fu wem ovkis zupsauf egawo vekvofaj gariti liv gitjorti.",
            label: "Business Address (Address, City, State, Zip)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          },
          {
            name: "previous_employer__supervisor_name",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Mi ha okevob ezveg injacoko setafav tas ufritem zew ja mavsuzlor zajzuro.",
            label: "Supervisor Name",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "previous_employer__supervisor_phone",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Wuali sohu domatuk ziguv tuz jecgi jien dujoge leuru af narovaru no.",
            label: "Supervisor Phone",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            tooltip_text: "A simple question that requires a one line response.",
            button: "Question",
            required: false,
            field_id: "single_line",
            value:
              "Jibucvoc sugmiira zuradsi wohifvad nilcipu sil erekuwu danahdo jil niv wuop ezaresah.",
            label: "Supervisor Email",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            name: "previous_employer__supervisor_email"
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Previous Employer"
      },
      {
        fields: [
          {
            name: "assets_and_income__annual_salary_of_applicant",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Ne en zenge keov tika feiwigud dis jin moog fugud keseto hutob uzbul cioma uculig.",
            label: "Annual Salary",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "assets_and_income__annual_salary_of_coapplicants",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Afi zoh jocajah salokreb doec dauke ano wak woril afa bezzuor icgirzuv munin petaik jopjetko hid.",
            label: "Annual Salary (Co-applicants, if any)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "assets_and_income__annual_income_from_assets",
            button: "Line",
            required: false,
            field_id: "single_line",
            value: "Dodvirto zempiter uku zemhal be kag talbilof kic zojpuw ruglir lij gu pow.",
            label: "Income From Assets",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "assets_and_income__additional_income_child_parent_alimony",
            button: "Line",
            required: false,
            field_id: "single_line",
            value:
              "Pehobfip savvu kifmafu koormi kigit kak labhukvi tihoscad isuzah gik gare nepamfa.",
            label: "Additional Income (Child & Parent, Alimony)",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          },
          {
            name: "assets_and_income__total_anticipated_annual_income",
            button: "Line",
            required: false,
            field_id: "single_line",
            summary: true,
            value: "$1,000,000.00",
            label: "Total Anticipated Annual Income",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-minus",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A simple question that requires a one line response."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Assets And Income"
      },
      {
        fields: [
          {
            name: "vehicles__vehicles",
            button: "Multi Line",
            required: false,
            field_id: "multi_line",
            summary: true,
            value: "None",
            label: "List Any Vehicles You Have (Vehicle Year, Make, Color, License #, State)",
            klass: null,
            help_text: "One vehicle per row",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "Vehicle Year, Make, Color, License #, State",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Vehicles"
      },
      {
        fields: [
          {
            name: "other_questions__convicted_of_crime",
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "No",
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Have you ever been convicted of a crime?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false"
          },
          {
            name: "other_questions__filed_for_bankruptcy",
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "Yes",
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Have you ever filed for bankruptcy?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false"
          },
          {
            name: "other_questions__previously_owned_home",
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "No",
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Have You Owned A Home In The Past?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false"
          },
          {
            name: "other_questions__is_smoker",
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "No",
            summary: true,
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Do you smoke?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false",
            undefined: "No"
          },
          {
            name: "other_questions__has_been_evicted",
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "Yes",
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Have you ever been evicted from a tenancy or left owing money?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false"
          },
          {
            name: "other_questions__is_united_states_veteran",
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "No",
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Optional: Are You A United States Veteran?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false",
            undefined: "No"
          }
        ],
        button: "Credit &amp; Criminal",
        section_id: "credit-criminal",
        label: "Other Questions"
      },
      {
        fields: [
          {
            name: "pets__has_pets",
            summary: true,
            icon: "icon-adjust",
            button: "Choice",
            required: false,
            field_id: "choice",
            value: "No",
            choices: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" }
            ],
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            label: "Do you have any pets?",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false"
          },
          {
            name: "pets__list_pets",
            summary: true,
            button: "Multi Line",
            required: false,
            field_id: "multi_line",
            value: "None",
            label: "If so, please list each pet (Type, Weight, Color)",
            klass: null,
            help_text: "One pet per line, please",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "Dog, 40lbs, Black",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Pets"
      },
      {
        fields: [
          {
            name: "c1913",
            button: "Text",
            required: false,
            field_id: "text_display",
            value: "",
            label:
              "Attachments must be image files (.jpg, .pdf, .png) under 5MB in size. \n\nComplete as relevant. If you have questions, please ask the property manager directly.",
            klass: null,
            help_text: "",
            validate: null,
            icon: "icon-font",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "For you to display text to the applicant, such as a notice. Applicant does not provide a response."
          },
          {
            name: "attachments__pay_stubs",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Pay Stubs",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__letter_of_employment",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Letter of Employment",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__bank_statement",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Bank Statement",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__tax_returns",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Tax Returns",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__previous_landlord_letter_of_reference",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Previous Landlord Letter of Reference",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__verification_of_additional_income",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Verification of Additional Income",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__photo_id",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Copy of Photo ID",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__additional_attachment_1",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Additional Attachment",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          },
          {
            name: "attachments__additional_attachment_2",
            button: "File",
            required: false,
            field_id: "file",
            value: "",
            label: "Additional Attachment",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-file",
            placeholder: "",
            display_in_builder: true,
            tooltip_text: "A file attachment or photo."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Attachments"
      },
      {
        fields: [
          {
            name: "extra_information__extra_information",
            button: "Multi Line",
            required: false,
            field_id: "multi_line",
            value:
              "Buur rojvaki fiwit ka goupo gikcusjos nidejef gu luk bi gulabme raijuku danolvon kazinji he sapepo.",
            label: "Is there anything else we should know?",
            klass: null,
            help_text: "",
            validate_text: "--",
            validate: "",
            icon: "icon-align-justify",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "A question that may require multiple lines to respond,<br> such as an address or a list."
          }
        ],
        button: "Custom Section",
        section_id: "custom-section",
        label: "Extra Information"
      },
      {
        fields: [
          {
            name: "authorization__authorization",
            button: "Text",
            required: false,
            field_id: "text_display",
            value: "",
            label:
              "I hereby apply to lease this rental property and I warrant that all statements above set forth are true.\n\nI hereby give my permission to communicate with my current and former landlord(s) or property manager(s) for the purpose of discussing any and all of the facts and circumstances of my current or former tenancy, as well as the other information listed above. I also give my permission to communicate with my current employer(s) and/or supervisor(s) for the purpose of verifying the employment information listed above. I understand there are no limitations or restrictions regarding what may be discussed or revealed.\n\nI am aware that a credit history, landlord/tenant court search and criminal background check may be done in conjunction with my application and I hereby authorize Rent Application to request the aforementioned reports. I understand that I may have the right to make a written request within a reasonable period of time to receive additional, detailed information about the nature and scope of this investigation.\n\nTYPING OR SIGNING MY FULL NAME  BELOW QUALIFIES AS MY LEGALLY BINDING SIGNATURE AS PER THE UNIFORM ELECTRONIC TRANSACTIONS ACT (UETA).",
            klass: null,
            help_text: "",
            validate: null,
            icon: "icon-font",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "For you to display text to the applicant, such as a notice. Applicant does not provide a response."
          },
          {
            name: "_signature",
            prefer_to_type: false,
            button: "Signature",
            required: true,
            field_id: "signature",
            value:
              '[{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null},{"mx":null,"my":null}]',
            label: "",
            klass: null,
            help_text: "",
            validate: null,
            icon: "icon-pencil",
            display_in_builder: true,
            tooltip_text: "Ask the applicant to electronically sign the document."
          },
          {
            name: "_signature_valid",
            button: "Text",
            required: false,
            field_id: "text_display",
            value: "",
            label:
              "Electronically signing this document and submitting this form constitutes a legally binding signature and consent to the preceding statement.",
            klass: null,
            help_text: "",
            validate: null,
            icon: "icon-font",
            placeholder: "",
            display_in_builder: true,
            tooltip_text:
              "For you to display text to the applicant, such as a notice. Applicant does not provide a response."
          }
        ],
        button: "Custom Section",
        section_id: "authorization",
        label: "Authorization"
      }
    ],
    slug: "sample@rentapplication.net",
    name: "My online application link",
    user_actions: [
      {
        action: "submit",
        username: "fu@fononma.gp",
        ip_address: "172.18.0.1",
        user_agent:
          "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.81 Safari/537.36",
        data: {},
        timestamp: "2021-10-24T18:13:07.721"
      }
    ],
    applicant_unit_address: {
      label: "555 Ridge Rd, Meaford, ON N4L 1L9, Canada",
      countryCode: "CAN",
      countryName: "Canada",
      stateCode: "ON",
      state: "Ontario",
      county: "Grey",
      city: "Meaford",
      street: "Ridge Rd",
      postalCode: "N4L 1L9",
      houseNumber: "555"
    }
  },
  show_accept_reject_button: true,
  landlord_can_edit: true,
  company_agents: [],
  reports: [
    {
      id: "sample_credit",
      html_url: "/reports/credit.html",
      report_type: "credit",
      status: "ready",
      created: "2021-10-24T18:13:17.850292-05:00",
      modified: "2021-10-24T18:13:17.850318-05:00",
      short_label: "Credit",
      identifier: "zipreports_transunion_credit",
      compliance_requirements: null,
      compliance_criteria: null,
      error_type: null,
      missing_fields: null,
      summary: [
        {
          label: "Credit score",
          value: "800"
        },
        {
          label: "Total debt balance",
          value: "$1000"
        },
        {
          label: "# accounts past due",
          value: "2"
        }
      ]
    },
    {
      id: "sample_eviction",
      report_type: "eviction",
      html_url: "/reports/eviction.html",
      status: "ready",
      created: "2021-10-24T18:13:17.917735-05:00",
      modified: "2021-10-24T18:13:25.353614-05:00",
      short_label: "Eviction",
      identifier: "redridge_eviction",
      summary: [
        {
          label: "# Records",
          value: "1"
        }
      ],
      compliance_requirements: null,
      compliance_criteria: null,
      error_type: null,
      missing_fields: null
    },
    {
      id: "sample_criminal",
      report_type: "criminal",
      html_url: "/reports/criminal.html",
      status: "ready",
      created: "2021-10-24T18:13:17.899309-05:00",
      modified: "2021-10-24T18:13:25.479324-05:00",
      short_label: "Criminal",
      identifier: "redridge_criminal",
      summary: [
        {
          label: "# Felonies",
          value: "1"
        },
        {
          label: "# Misdemeanors",
          value: "1"
        },
        {
          label: "# Undetermined",
          value: "0"
        }
      ],
      compliance_requirements: null,
      compliance_criteria: null,
      error_type: null,
      missing_fields: null
    }
  ],
  bundle: { slug: "sample", applications: [] },
  shares: [],
  is_new: true
}
